import createAsyncActionType from "../utilities/createAsyncActionType";

export const GET_SCORE_CARDS_BY_TYPE = createAsyncActionType(
  "GET_SCORE_CARDS_BY_TYPE"
);

export const CLEAR_SCORE_CARDS_BY_TYPE = "CLEAR_SCORE_CARDS_BY_TYPE";



// WEBPACK FOOTER //
// ./src/types/getScoreCardsByTypeTypes.js